import { render } from "./FuncaoAndCargo.vue?vue&type=template&id=79463f3e&scoped=true"
import script from "./FuncaoAndCargo.vue?vue&type=script&lang=js"
export * from "./FuncaoAndCargo.vue?vue&type=script&lang=js"

import "./FuncaoAndCargo.vue?vue&type=style&index=0&id=79463f3e&scoped=true&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sgp-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79463f3e"]])

export default __exports__